<template>
  <section>
    <!-- top-menu -->
    <top-menu/>

    <div class="page-content list-detail-content">
      <div class="container-fluid">
        <div class="page-content-inner">
          <div class="row">
            <!-- Loading from page -->
            <full-loading v-if="loadingList"/>
            <!-- List Details -->
            <div v-if="!loadingList" class="col-md-12 box-default">
              <div class="col-md-12 list-detail-card">
                <div class="list-detail-card-header">
                  <div class="title-list-detail">
                    <label class="label-icon-list-detail">
                      <ion-icon name="business-outline"></ion-icon>
                      Unidades de negócio
                    </label>
                    <span>Lista de unidades de negócio</span>
                  </div>
                  <span class="list-detail-total">
                    Quantidade total ({{ responseData.length }})
                  </span>
                </div>
                <div class="list-detail-card-content">
                  <table class="list-detail-table">
                    <thead>
                    <tr>
                      <th>Empresa</th>
                      <th>Nome fantasia</th>
                      <th>CNPJ/CPF</th>
                      <th>Ações</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(value, index) in responseData">
                      <td class="company-name">
                        <a :title="value.company.name">{{ value.company.name }}</a>
                      </td>
                      <td class="company-name">
                        {{ value.bussinessInfo.representationName }}
                      </td>
                      <td class="number-document">
                        <span>
                          {{ value.bussinessInfo.cnpj | cpfOrCnpj }}
                          <span class="icon" title="Alterar CNPJ/CPF" v-on:click="changeData(value.id)">
                            <ion-icon name="create-outline"></ion-icon>
                          </span>

                        </span>
                      </td>
                      <td class="actions">
                        <button>
                          <ion-icon name="chevron-forward"></ion-icon>
                        </button>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- modals -->
        <div class="modal fade" id="change-data-modal" role="dialog">
          <div class="modal-dialog">
            <div class="modal-dialog">
              <div class="modal-content content">
                <div class="modal-header">
                  <a type="button" class="close-btn" data-dismiss="modal">
                    <ion-icon name="close"></ion-icon>
                  </a>
                  <div class="title-group">
                    <ion-icon name="create-outline"></ion-icon>
                    <h4 class="title-modal">Alterar CNPJ/CPF</h4>
                  </div>
                  <div class="subtitle">
                    <span>Altere o CNPJ/CPF da unidade de negócio</span>
                  </div>
                </div>
                <div class="modal-body">
                  <div class="change-data">
                    <input type="text" v-mask="['##.###.###/####-##', '###.###.###-##']" id="input-text"
                           v-model="modalDataChange" autocomplete="off"
                           placeholder="Novo CNPJ/CPF"/>
                    <button class="btn-validate" @click="changeDataConfirm()" data-dismiss="modal"
                            data-backdrop="false">
                      <span v-if="!loadingChangeData">Confirmar</span>
                      <div class="loading-btn" v-else>
                        <div class="spinner-btn">
                          <div class="rect1"></div>
                          <div class="rect2"></div>
                          <div class="rect3"></div>
                          <div class="rect4"></div>
                          <div class="rect5"></div>
                        </div>
                      </div>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Footer -->
    <footer-menu v-if="!loadingList"/>
  </section>


</template>

<script>
import topMenu from "../../components/default/topMenu.vue";
import fullLoading from "../../components/default/fullLoading.vue";
import footerMenu from "../../components/default/footerMenu.vue";
import {GET_UNIT_MASTER, CHANGE_DATA_BUSINESS_UNITS} from "../../../../urlConfig";
import {REQUEST_SERVICE, UTIL_SERVICE} from "../../../../requestConfig";
import swal from "sweetalert";

export default {
  name: "listBusinessUnits",
  components: {
    topMenu,
    fullLoading,
    footerMenu
  },
  data() {
    return {
      loadingList: false,
      loadingChangeData: false,
      responseData: '',
      modalDataChange: '',
      businessUnitId: '',
    }
  },
  methods: {
    getList() {
      this.loadingList = true;

      let url = GET_UNIT_MASTER;
      url += "?i=" + this.$route.params.idCompany;
      REQUEST_SERVICE.requestContext("GET", url, this.$route.params.context)
        .then((response) => {
          UTIL_SERVICE.console("RESULT GET_UNIT_MASTER:", response.data);

          this.loadingList = false;
          this.responseData = response.data;
        })
        .catch((reason) => {
          this.loadingList = false;

          reason.response.data.erros.map((value, index) => {
            swal("Aviso", value.value, "error");
          });
        });
    },
    changeData(id) {
      this.businessUnitId = id

      $("#change-data-modal").modal();
    },
    changeDataConfirm() {
      this.loadingChangeData = true;
      this.modalDataChange = this.modalDataChange.replace(/\D/g, '')

      UTIL_SERVICE.console("DATA SEND:", CHANGE_DATA_BUSINESS_UNITS);
      REQUEST_SERVICE.requestContext("PUT", CHANGE_DATA_BUSINESS_UNITS, this.$route.params.context, {
        id: this.businessUnitId,
        document: this.modalDataChange,
      })
        .then((response) => {
          UTIL_SERVICE.console("RESULT CHANGE_ID_IUGU:", response.data);

          this.getList();
          this.loadingChangeData = false;

          swal("Sucesso", response.data, "success");
        })
        .catch((reason) => {
          this.loadingChangeData = false;

          reason.response.data.erros.map((value, index) => {
            swal("Aviso", value.value, "error");
          });
        });
    }
  },
  beforeMount() {
    this.getList();
  }
}
</script>

<style lang="scss" scoped>

.list-detail-content {
  .box-default {
    border-radius: 10px !important;
    padding: 20px 30px;
    background: #ffffff;
    min-height: 58rem;

    .list-detail-card {
      padding: 0;

      .list-detail-card-header {
        display: flex;
        justify-content: space-between;

        .title-list-detail {
          padding: 0;

          .label-icon-list-detail {
            margin: 0;
            display: flex;
            align-items: center;
            font-size: 18px;
            font-weight: 700;
            color: var(--classic-black);

            ion-icon {
              margin-right: 5px;
              font-size: 23px;
              color: var(--dark-gray);
            }
          }

          span {
            font-size: 14px;
            font-weight: 400;
            color: var(--dark-gray);
          }
        }

        .list-detail-total {
          position: relative;

          color: var(--dark-gray);
          font-size: 16px;
          font-weight: 500;

          .btn-excel {
            position: absolute;
            bottom: -15px;
            right: 0;

            display: flex;
            align-items: center;

            padding: 4px 20px;
            background: var(--light-green);
            color: #ffffff;
            border-radius: 4px !important;
            border: none;
            text-decoration: none;

            &:hover {
              background: #17a24f;
            }

            span {
              font-size: 14px;
            }

            ion-icon {
              margin-right: 5px;
            }
          }
        }
      }


    }

    .list-detail-card-content {
      margin-top: 40px;
      //overflow: auto;
      //max-height: 80rem;

      .list-detail-table {
        position: relative;

        width: 100%;
        margin-bottom: 20px;

        thead {
          position: sticky;
          top: 0;
          z-index: 1;
          font-size: 14px;
          color: var(--high-gray);
          line-height: 220%;
          padding-bottom: 5px;
          border-bottom: 1px solid var(--classic-gray);
          background: var(--classic-white);

          tr {
            th {
              font-weight: 500 !important;
              line-height: 100%;
              padding-bottom: 10px;
            }
          }
        }

        tbody {
          tr {
            border-bottom: 1px solid var(--classic-gray);

            .company-name {
              color: var(--dark-gray);
              padding: 20px 0;

              a {
                display: list-item;
                width: 150px;
                white-space: nowrap;
                overflow: hidden !important;
                text-overflow: ellipsis;
                font-size: 14px;
                font-weight: 500;
                color: var(--high-blue);
                align-items: center;
              }
            }

            .requester-name {
              color: var(--dark-gray);
            }

            .requested-at {
              display: flex;
              flex-direction: column;
              margin-top: 11px;
              margin-right: 30px;

              font-size: 14px;
              font-weight: 400;
              color: var(--dark-gray);
              padding: 0 20px 0 10px;

              span {
                font-size: 12px;
                font-weight: 400;
                color: var(--high-gray);
              }
            }

            .experiences {
              color: var(--dark-gray);

              span {
                display: list-item;
                width: 140px;
                white-space: nowrap;
                overflow: hidden !important;
                text-overflow: ellipsis;
                align-items: center;
              }
            }

            .number-document {
              span {
                display: flex;

                color: var(--dark-gray);

                .icon {
                  color: var(--high-blue);
                  cursor: pointer;
                  margin-left: 10px;

                  &:hover {
                    color: #1d167d;
                  }

                  ion-icon {
                    font-size: 18px;
                    pointer-events: none;
                  }
                }
              }
            }

            .actions {
              button {
                display: flex;
                justify-content: center;
                align-items: center;

                background: var(--background-gray);
                width: 32px;
                height: 32px;
                padding: 0;
                border: none;
                border-radius: 4px !important;
                transition: 0.2s;

                ion-icon {
                  color: var(--dark-gray);
                  font-size: 22px;
                  transition: 0.2s;
                }

                &:hover {
                  background: var(--high-blue);

                  ion-icon {
                    color: var(--classic-white);
                  }
                }
              }
            }

            .want-files {
              //width: 10%;
              color: var(--dark-gray);
            }

            .contact-name {
              //width: 10%;
              color: var(--dark-gray);
            }

            .phone {
              //width: 10%;
              color: var(--dark-gray);
            }

            .contact-time {
              //width: 10%;
              color: var(--dark-gray);
            }

            .reason {
              //width: 10%;
              color: var(--dark-gray);

              span {
                display: list-item;
                width: 140px;
                white-space: nowrap;
                overflow: hidden !important;
                text-overflow: ellipsis;
                align-items: center;
              }
            }

            .another-competitor {
              //width: 10%;
              color: var(--dark-gray);
              padding-right: 20px;

              span {
                display: list-item;
                width: 140px;
                white-space: nowrap;
                overflow: hidden !important;
                text-overflow: ellipsis;
                align-items: center;
              }
            }

            .ip {
              //width: 10%;
              color: var(--dark-gray);
            }
          }
        }
      }
    }

    .list-detail-card-content::-webkit-scrollbar {
      width: 4px;
      height: 4px;
      position: absolute;
    }

    .list-detail-card-content::-webkit-scrollbar-track {
      background-color: #e6e9ec;
      border-radius: 6px;
    }

    .list-detail-card-content::-webkit-scrollbar-thumb {
      background: #3a424e;
      border-radius: 6px;
    }

    .list-detail-card-content::-webkit-scrollbar-thumb:hover {
      background: lighten(#3a424e, 5%);
      transition: 0.5s;
    }
  }
}

#change-data-modal {
  .modal-dialog {
    width: 500px;
    margin-top: 15%;

    .content {
      border: none;
      box-shadow: none;
      border-radius: 8px !important;

      .modal-header {
        position: relative;
        padding: 20px 30px;
        border-bottom: none;

        .title-group {
          display: flex;
          align-items: flex-end;

          ion-icon {
            margin-right: 5px;
            font-size: 23px;
            color: var(--dark-gray);
          }

          .title-modal {
            margin: 0;
            text-align: left;
            display: flex;
            align-items: center;
            font-size: 18px;
            font-weight: 700;
            color: var(--classic-black);
          }
        }

        .subtitle {
          span {
            margin-top: 5px;
            margin-left: 4px;
            font-size: 14px;
            font-weight: 400;
            color: var(--dark-gray);
          }
        }

        .close-btn {
          position: absolute;
          right: 26px;
          top: 16px;
          height: 20px;
          color: var(--light-red);

          &:hover {
            color: var(--high-red);
          }

          ion-icon {
            font-size: 20px;
            pointer-events: none;
          }
        }
      }

      .modal-body {
        padding: 0 30px 20px;

        .change-data {
          display: flex;
          position: relative;

          ion-icon {
            position: absolute;
            right: 10px;
            top: 10px;
            font-size: 16px;
            color: var(--dark-gray);
          }

          input {
            width: 100%;
            background: #EEF2F7;
            border-radius: 4px !important;
            padding: 6px 12px;
            border: 1px solid #EEF2F7;
            transition: .2s;
            margin-right: 20px;

            font-size: 16px;
            font-weight: 400;
            color: var(--dark-gray);

            &::placeholder {
              font-size: 16px;
              font-weight: 400;
              color: var(--dark-gray);
            }

            &:hover {
              transition: .2s;
              border: 1px solid #cacaca;
            }

            &:focus-visible {
              outline: none;
              transition: .2s;
              border: 1px solid #cacaca;

              &::placeholder {
                transition: .1s;
                color: #EEF2F7;
              }
            }
          }

          .btn-validate {
            background: #2F23D6;
            color: #ffffff;
            border-radius: 4px !important;
            border: none;
            padding: 0 20px;

            &:hover {
              background: #20179e;
            }
          }
        }
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/vue/pages/restricted/companyDetail/listBusinessUnits.vue